import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';


import './topicsselect.css';

const TopicsSelect = ({
  topics,
  onChange,
  isOpen = true,
  value,
  currentTopics=[] // topics already selected in current category
}) => {
  const [topic, setTopic] = useState('');

  // console.log('topics in TopicsSelect ((((((((((((((((((',topics);

  useEffect(() => {
    if (value && value._id) {
      setTopic(value._id);
    }
  }, [value]);

  let onlyTopicsNames=[];
  // only current topics names
  if(currentTopics.length) {
    onlyTopicsNames=currentTopics.map(elem => elem.topic ? elem.topic : elem);
  }

  const findTopic = (_id) => {
    let topic;
    topics.some((elem) => {
      topic = elem.topics.find(elem => elem._id === _id);
      return topic;
    });
    return topic;
  }

  let list = topics.reduce((accum, curr) => {
    let { topics, category } = curr;
    if (topics) {
      topics=topics.filter(elem=>!onlyTopicsNames.includes(elem.name));
      const arr = topics.map((topic) => ({ category, value: topic._id, label: topic.name }));
      return [...accum, ...arr];
    }
    return accum;
  }, []);

  // console.log('list33',list);

  if (!isOpen) {
    return false;
  }

  const onChangeWrapper = ({ target: { value } }) => {
    // onChange(value);
    setTopic(value);

    if (value && value !== 'CUSTOM') {
      const topic = findTopic(value);
      onChange(topic);
    } else {
      onChange(value);
    }
  }

  // const items=list.map(elem=>{
  //   const {value,label}=elem;
  //   return (
  //     <p onClick={onChangeWrapper(value)}>{label}</p>
  //   )
  // });

  const defaultItems = [
    { value: '', label: ' -- Choose a topic -- ' },
    { value: 'CUSTOM', label: 'CUSTOM TOPIC' }
  ]
  list = [...defaultItems, ...list];


  let currentCat=list[0].category,groups=[];
  let items = list.reduce((accum,curr, index) => {
    const { value, label, category } = curr;

    const option=<option key={'topics-combo_' + index} value={value}>{label}</option>;
    if(category!==currentCat) {
      const optGroup=<optgroup key={'topics-group__'+index} label={currentCat}>{groups}</optgroup>
      currentCat=category;
      groups=[];
      accum=[...accum,optGroup]
    }
    groups.push(option);
    return accum;
  },[]);


  return (
    <select onChange={onChangeWrapper} value={topic} className="topicsselect">
      {items}
    </select>
  )
}

const mapState2Props = ({ topics }) => ({
  topics: topics.topics
})

export default connect(mapState2Props)(TopicsSelect);